import React from "react";
import { Star } from "lucide-react";

export default function Rating({ value = 0, count, size = "sm", showCount = true, className = "" }) {
  const full = Math.floor(value);
  const half = value - full >= 0.4 && value - full < 0.9;
  const dims = size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5";
  const text = size === "lg" ? "text-sm" : "text-xs";

  return (
    <div data-testid="rating" className={`inline-flex items-center gap-2 ${className}`}>
      <div className="inline-flex items-center gap-0.5">
        {Array.from({ length: 5 }).map((_, i) => {
          const filled = i < full || (i === full && half);
          return (
            <Star
              key={i}
              className={`${dims} ${filled ? "fill-butter text-butter" : "text-ink/15"}`}
              strokeWidth={1.5}
            />
          );
        })}
      </div>
      <span className={`tabular-nums font-medium ${text}`}>{value.toFixed(1)}</span>
      {showCount && count !== undefined && (
        <span className={`text-muted ${text}`}>({count})</span>
      )}
    </div>
  );
}
